<div class="finzy-portfolio-title row">
  <p *ngIf="!editMode" [style.color]="color" class="col-md-12">
    <span style="overflow: hidden; text-overflow: ellipsis;">{{title | slice:0:35 }}</span>
    <i class="material-icons finzy-edit-icon" (click)="onEditModeTurnedOn()" style="cursor: pointer;">mode_edit</i>
  </p>
  <p *ngIf="editMode" class="col-md-12">
    <span class="finzy-investment-edit">
      <input #titleField type="text" name="investment" value="{{ title }}" [style.color]="editTextColor" [style.borderBottomColor] = "editTextColor"/>
      </span>
    <i class="material-icons finzy-save-icon" [style.color]="editColor" (click)="saveTitle(titleField.value)">save</i>
  </p>
</div>
